import { BrandColors } from '../theme';

export const buttonTokens = {
    root: {
        borderRadius: '24px',
        paddingX: '1rem',
        paddingY: '0.5rem',
        roundedBorderRadius: '2rem',
        gap: '0.5rem',
        iconOnlyWidth: '2.5rem',
        background: BrandColors.primary[500],
        hoverBackground: BrandColors.primary[600],
        activeBackground: BrandColors.primary[700],
        borderColor: BrandColors.primary[500],
        hoverBorderColor: BrandColors.primary[600],
        activeBorderColor: BrandColors.primary[700],
        color: BrandColors.semantic.textInverse,
        disabledBackground: BrandColors.surface[200],
        disabledBorderColor: BrandColors.surface[200],
        disabledColor: BrandColors.surface[500],
        invalidBorderColor: BrandColors.red[500],
    },
    colorScheme: {
        light: {
            root: {
                primary:{
                    
                }
            },
            outlined: {
                primary: {
                    hoverBackground: 'rgba(139, 92, 246, 0.04)',
                    activeBackground: BrandColors.surface[100],
                    borderColor: BrandColors.primary[500],
                    color: BrandColors.primary[500],
                    padding:'0.5rem 1rem !important' ,
                }
            }
                },

        text: {
            primary:{
                fontWeight: '700',
                fontSize: '14px',
            }

        }                 
}
};